import { ArticleCommentCount } from './ArticleCommentCount'
import { ArticleComments } from './ArticleComments'

export { ArticleCommentCount }
export default ArticleComments
